import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import logo from 'assets/img/benito-santos-mexico.svg';
class PagesHeader extends Component {
    constructor(props) {
        super(props);
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
        this.state = {
            width: window.innerWidth
        };
    }
    // function that sets the class to active of the active page
    activeRoute(routeName) {
        return window.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }
    // function that shows/hides sidebar on responsive
    mobileSidebarToggle(e) {
        document.documentElement.classList.toggle('nav-open');
    }
    updateWidth() {
        this.setState({ width: window.innerWidth });
    }
    componentDidMount() {
        window.addEventListener('resize', this.updateWidth.bind(this));
    }
    render() {
        return (
            <Navbar
                collapseOnSelect
                inverse
                className="navbar-primary navbar-transparent navbar-absolute"
            >
                <Navbar.Header>
                    <Navbar.Brand>
                        <NavLink to={'/inicio'} className="nav-link">
                            {this.state.width > 429 ? (
                                <img src={logo} alt="" height="32" />
                            ) : (
                                'Benito Santos'
                            )}
                        </NavLink>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                </Navbar.Header>
                <Navbar.Collapse>
                    <ul className="nav navbar-nav navbar-right">
                        {/* <li>
              <NavLink to={"/inicio"} className="nav-link">
                <i className="fa fa-th-list" />
                <p>Inicio</p>
              </NavLink>
            </li> */}
                        <li className={this.activeRoute('login-page')}>
                            <NavLink
                                to={'/iniciar-sesion'}
                                className="nav-link"
                            >
                                <i className="fa fa-drivers-license-o" />
                                <p>Iniciar sesión</p>
                            </NavLink>
                        </li>

                        {/*<li className={this.activeRoute("register-page")}>
              <NavLink to={"/crear-cuenta"} className="nav-link">
                <i className="fa fa-user-circle-o" />
                <p>Crear cuenta</p>
              </NavLink>
            </li>*/}
                        {/* <li className={this.activeRoute("lock-screen-page")}>
              <NavLink to={"/reiniciar-sesion"} className="nav-link">
                <i className="fa fa-lock" />
                <p>Lock Screen</p>
              </NavLink>
            </li> */}
                    </ul>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default PagesHeader;



// WEBPACK FOOTER //
// ./src/components/Header/PagesHeader.jsx